(function(){
  'use strict';

  var PRODUCT_IDS = {
    '5291622170775': true,
    '5294850048151': true,
    '5305726140567': true,
    '7994224836759': true
  };

  var PLANS = [
    { id: '3258548375', label: 'Every 2 weeks' },
    { id: '3258581143', label: 'Every month' },
    { id: '3258613911', label: 'Every 6 weeks' },
    { id: '3258646679', label: 'Every 2 months' }
  ];

  var cartState = null;
  var busy = false;
  var internalCartEvent = false;

  function isPhone(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function routeRoot(){
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function cartUrl(path){
    return routeRoot() + path.replace(/^\//, '');
  }

  function currentPlanId(item){
    var allocation = item && item.selling_plan_allocation;
    var plan = allocation && allocation.selling_plan;
    return plan && plan.id != null ? String(plan.id) : '';
  }

  function cards(){
    return Array.prototype.slice.call(document.querySelectorAll('.cart_items .cart-item'));
  }

  function rowIndex(card){
    return cards().indexOf(card);
  }

  function lineKey(card){
    if (!card) return '';
    var key = card.getAttribute('data-bgc-key') || '';
    if (key) return key;
    var input = card.querySelector('input.quantity[data-bgc-key]');
    return input ? (input.getAttribute('data-bgc-key') || '') : '';
  }

  function setLineKey(card, key){
    if (!card || !key) return;
    card.setAttribute('data-bgc-key', key);
    var quantityRow = card.querySelector('.bgc-cart-quantity-row');
    var input = card.querySelector('input.quantity');
    var panel = card.querySelector('.bgc-mobile-fullcart-purchase');
    if (quantityRow) quantityRow.setAttribute('data-bgc-key', key);
    if (input) input.setAttribute('data-bgc-key', key);
    if (panel) panel.setAttribute('data-bgc-key', key);
  }

  function updateCounts(cart){
    var count = cart && cart.item_count ? cart.item_count : 0;
    document.querySelectorAll('.cart_count').forEach(function(el){ el.textContent = count; });
    var mobile = document.querySelector('.mobile-icons .cart-button span');
    if (mobile) mobile.textContent = count;
  }

  function addStyles(){
    if (document.getElementById('bgc-fullcart-purchase-options-style')) return;
    var style = document.createElement('style');
    style.id = 'bgc-fullcart-purchase-options-style';
    style.textContent = [
      '.bgc-mobile-fullcart-purchase{display:none}',
      '@media(max-width:767px){',
      '.cart_items .cart-item>.QQQ>.bgc-mobile-fullcart-purchase{display:block!important;grid-column:1 / -1!important;width:100%!important;max-width:none!important;margin:14px 0 8px!important;padding:12px 13px!important;box-sizing:border-box!important;border:1px solid #ead7c5!important;border-radius:10px!important;background:#fffaf5!important;color:#351814!important}',
      '.cart_items .cart-item>.QQQ>.bgc-mobile-fullcart-purchase .bgc-fullcart-purchase__options{display:grid!important;grid-template-columns:1fr 1fr!important;gap:8px!important;flex-wrap:nowrap!important}',
      '.cart_items .cart-item>.QQQ>.bgc-mobile-fullcart-purchase .bgc-fullcart-purchase__btn{width:100%!important;min-height:44px!important;padding:9px 8px!important;text-align:center!important;justify-content:center!important;box-sizing:border-box!important}',
      '.bgc-fullcart-purchase__title{margin:0 0 8px!important;font-size:11px!important;font-weight:800!important;letter-spacing:.03em!important;color:#A8342F!important}',
      '.bgc-fullcart-purchase__btn{display:flex!important;align-items:center!important;border:1px solid #d7b47c!important;border-radius:7px!important;background:#fff!important;color:#8f2f2a!important;font-size:11px!important;font-weight:800!important;line-height:1.15!important;cursor:pointer!important}',
      '.bgc-fullcart-purchase__btn.is-active{background:#DDA62F!important;border-color:#DDA62F!important;color:#fff!important}',
      '.bgc-fullcart-purchase__btn:disabled,.bgc-fullcart-purchase__select:disabled{opacity:.58!important;cursor:wait!important}',
      '.bgc-fullcart-purchase__frequency{margin-top:9px!important}',
      '.bgc-fullcart-purchase__frequency[hidden]{display:none!important}',
      '.bgc-fullcart-purchase__frequency label{display:block!important;margin:0 0 5px!important;font-size:11px!important;font-weight:700!important;color:#351814!important}',
      '.bgc-fullcart-purchase__select{display:block!important;width:100%!important;min-height:44px!important;margin:0!important;padding:8px 34px 8px 10px!important;border:1px solid #d7b47c!important;border-radius:7px!important;background:#fff!important;color:#351814!important;font-size:13px!important;box-sizing:border-box!important}',
      '.bgc-fullcart-purchase__status{min-height:15px!important;margin:6px 0 0!important;font-size:11px!important;line-height:1.25!important;color:#6f633f!important}',
      'body .cart_items .cart-item>.QQQ>.bgc-cart-quantity-row{gap:5px!important}',
      'body .cart_items .cart-item .bgc-cart-quantity-row .quantity_label{font-size:0!important;min-width:22px!important}',
      'body .cart_items .cart-item .bgc-cart-quantity-row .quantity_label:after{content:"Qty";font-size:11px!important;font-weight:700!important}',
      'body .cart_items .cart-item .bgc-cart-quantity-row input.quantity{width:44px!important;min-width:44px!important;padding:5px 3px!important}',
      '.bgc-fullcart-qty-btn{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:38px!important;height:42px!important;min-width:38px!important;margin:0!important;padding:0!important;border:1px solid #d9c9b8!important;border-radius:8px!important;background:#fff!important;color:#351814!important;text-decoration:none!important;font-size:23px!important;font-weight:700!important;line-height:1!important;box-sizing:border-box!important;touch-action:manipulation!important}',
      '.bgc-fullcart-qty-btn:active{transform:translateY(1px)}',
      '.bgc-fullcart-qty-btn.is-disabled,.bgc-phone-remove.is-disabled{opacity:.48!important;pointer-events:none!important}',
      '.cart_items .cart-item .bgc-cart-quantity-row input.quantity{appearance:textfield!important;-moz-appearance:textfield!important}',
      '.cart_items .cart-item .bgc-cart-quantity-row input.quantity::-webkit-inner-spin-button,.cart_items .cart-item .bgc-cart-quantity-row input.quantity::-webkit-outer-spin-button{-webkit-appearance:none!important;margin:0!important}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function fetchCart(){
    return fetch(cartUrl('cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function(response){
      if (!response.ok) throw new Error('Cart read failed');
      return response.json();
    });
  }

  function postChange(payload){
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function(response){
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    });
  }

  function setBusy(card, on, message){
    busy = !!on;
    document.querySelectorAll('.bgc-fullcart-qty-btn,.bgc-phone-remove').forEach(function(control){
      control.classList.toggle('is-disabled', !!on);
      control.setAttribute('aria-disabled', on ? 'true' : 'false');
    });
    document.querySelectorAll('.bgc-mobile-fullcart-purchase button,.bgc-mobile-fullcart-purchase select').forEach(function(control){
      control.disabled = !!on;
    });
    if (card) {
      var status = card.querySelector('.bgc-fullcart-purchase__status');
      if (status) status.textContent = message || '';
    } else if (!on) {
      document.querySelectorAll('.bgc-fullcart-purchase__status').forEach(function(status){ status.textContent = ''; });
    }
  }

  function ensureQuantityControls(card, item, index){
    var row = card && card.querySelector('.bgc-cart-quantity-row');
    var input = row && row.querySelector('input.quantity');
    if (!row || !input || !item) return;

    var minus = row.querySelector('.bgc-fullcart-minus');
    if (!minus) {
      minus = document.createElement('a');
      minus.className = 'bgc-fullcart-qty-btn bgc-fullcart-minus';
      minus.setAttribute('aria-label', 'Decrease quantity');
      minus.textContent = '−';
      input.insertAdjacentElement('beforebegin', minus);
    }

    var plus = row.querySelector('.bgc-fullcart-plus');
    if (!plus) {
      plus = document.createElement('a');
      plus.className = 'bgc-fullcart-qty-btn bgc-fullcart-plus';
      plus.setAttribute('aria-label', 'Increase quantity');
      plus.textContent = '+';
      input.insertAdjacentElement('afterend', plus);
    }

    minus.href = cartUrl('cart/change?line=' + (index + 1) + '&quantity=' + Math.max(0, item.quantity - 1));
    plus.href = cartUrl('cart/change?line=' + (index + 1) + '&quantity=' + (item.quantity + 1));
    minus.classList.toggle('is-disabled', busy);
    plus.classList.toggle('is-disabled', busy);
  }

  function makePanel(card){
    var host = card && card.querySelector('.QQQ');
    var quantityRow = host && host.querySelector('.bgc-cart-quantity-row');
    if (!host || !quantityRow) return null;

    var panel = card.querySelector('.bgc-mobile-fullcart-purchase');
    if (panel) return panel;

    panel = document.createElement('div');
    panel.className = 'bgc-mobile-fullcart-purchase';

    var title = document.createElement('p');
    title.className = 'bgc-fullcart-purchase__title';
    title.textContent = 'PURCHASE OPTIONS';

    var options = document.createElement('div');
    options.className = 'bgc-fullcart-purchase__options';

    var oneTime = document.createElement('button');
    oneTime.type = 'button';
    oneTime.className = 'bgc-fullcart-purchase__btn';
    oneTime.setAttribute('data-bgc-fullcart-action', 'one-time');
    oneTime.textContent = 'ONE-TIME';

    var subscribe = document.createElement('button');
    subscribe.type = 'button';
    subscribe.className = 'bgc-fullcart-purchase__btn';
    subscribe.setAttribute('data-bgc-fullcart-action', 'subscribe');
    subscribe.textContent = 'SUBSCRIBE & SAVE';

    options.appendChild(oneTime);
    options.appendChild(subscribe);

    var frequency = document.createElement('div');
    frequency.className = 'bgc-fullcart-purchase__frequency';

    var label = document.createElement('label');
    label.textContent = 'Delivery frequency';

    var select = document.createElement('select');
    select.className = 'bgc-fullcart-purchase__select';
    select.setAttribute('aria-label', 'Subscription delivery frequency');

    for (var p = 0; p < PLANS.length; p++) {
      var option = document.createElement('option');
      option.value = PLANS[p].id;
      option.textContent = PLANS[p].label;
      select.appendChild(option);
    }

    frequency.appendChild(label);
    frequency.appendChild(select);

    var status = document.createElement('p');
    status.className = 'bgc-fullcart-purchase__status';
    status.setAttribute('aria-live', 'polite');

    panel.appendChild(title);
    panel.appendChild(options);
    panel.appendChild(frequency);
    panel.appendChild(status);
    quantityRow.insertAdjacentElement('afterend', panel);
    return panel;
  }

  function renderPanel(card, item){
    var existing = card.querySelector('.bgc-mobile-fullcart-purchase');
    if (!item || !PRODUCT_IDS[String(item.product_id)]) {
      if (existing) existing.remove();
      return;
    }

    var panel = existing || makePanel(card);
    if (!panel) return;

    var activePlan = currentPlanId(item);
    var oneTime = panel.querySelector('[data-bgc-fullcart-action="one-time"]');
    var subscribe = panel.querySelector('[data-bgc-fullcart-action="subscribe"]');
    var frequency = panel.querySelector('.bgc-fullcart-purchase__frequency');
    var select = panel.querySelector('.bgc-fullcart-purchase__select');
    var status = panel.querySelector('.bgc-fullcart-purchase__status');

    panel.setAttribute('data-bgc-current-plan', activePlan);
    panel.setAttribute('data-bgc-key', item.key || '');

    if (oneTime) {
      oneTime.classList.toggle('is-active', !activePlan);
      oneTime.setAttribute('aria-pressed', activePlan ? 'false' : 'true');
      oneTime.disabled = busy;
    }
    if (subscribe) {
      subscribe.classList.toggle('is-active', !!activePlan);
      subscribe.setAttribute('aria-pressed', activePlan ? 'true' : 'false');
      subscribe.disabled = busy;
    }
    if (frequency) frequency.hidden = !activePlan;
    if (select) {
      select.value = activePlan || PLANS[0].id;
      select.disabled = busy;
    }
    if (status && !busy) status.textContent = '';
  }

  function applyCartState(cart){
    if (!cart || !cart.items) return;
    cartState = cart;
    var currentCards = cards();
    for (var i = 0; i < currentCards.length; i++) {
      var item = cart.items[i];
      var card = currentCards[i];
      if (!item || !card) continue;
      setLineKey(card, item.key || '');
      var input = card.querySelector('input.quantity');
      if (input) {
        input.value = item.quantity;
        input.readOnly = true;
        input.setAttribute('aria-readonly', 'true');
      }
      ensureQuantityControls(card, item, i);
      renderPanel(card, item);
    }
    updateCounts(cart);
  }

  function findFreshCard(freshCards, key, fallbackIndex){
    if (key) {
      for (var i = 0; i < freshCards.length; i++) {
        if ((freshCards[i].getAttribute('data-bgc-key') || '') === key) return freshCards[i];
      }
    }
    return freshCards[fallbackIndex] || null;
  }

  function syncNode(currentRoot, freshRoot, selector){
    if (!currentRoot || !freshRoot) return;
    var current = currentRoot.querySelector(selector);
    var fresh = freshRoot.querySelector(selector);
    if (current && fresh) current.innerHTML = fresh.innerHTML;
  }

  function syncDiscountRows(currentCard, freshCard){
    var currentHost = currentCard && currentCard.querySelector('.QQQ');
    var freshHost = freshCard && freshCard.querySelector('.QQQ');
    if (!currentHost || !freshHost) return;
    currentHost.querySelectorAll('.applied_discount').forEach(function(node){ node.remove(); });
    var lineTotal = currentHost.querySelector('.bgc-line-total');
    if (!lineTotal) return;
    freshHost.querySelectorAll('.applied_discount').forEach(function(node){
      lineTotal.insertAdjacentElement('beforebegin', node.cloneNode(true));
    });
  }

  function syncBreakdown(currentDoc, freshDoc){
    var currentBreakdown = currentDoc.querySelector('.cart-breakdown');
    var freshBreakdown = freshDoc.querySelector('.cart-breakdown');
    if (!currentBreakdown || !freshBreakdown) return;

    var currentDiscounts = currentBreakdown.querySelector('.discounts');
    var freshDiscounts = freshBreakdown.querySelector('.discounts');
    if (freshDiscounts) {
      if (currentDiscounts) {
        currentDiscounts.innerHTML = freshDiscounts.innerHTML;
      } else {
        var subtotalTitle = currentBreakdown.querySelector('.subtotal');
        if (subtotalTitle) subtotalTitle.insertAdjacentElement('beforebegin', freshDiscounts.cloneNode(true));
      }
    } else if (currentDiscounts) {
      currentDiscounts.remove();
    }

    var currentSubtotal = currentBreakdown.querySelector('.subtotal_amount');
    var freshSubtotal = freshBreakdown.querySelector('.subtotal_amount');
    if (currentSubtotal && freshSubtotal) {
      currentSubtotal.className = freshSubtotal.className;
      currentSubtotal.innerHTML = freshSubtotal.innerHTML;
    }

    var currentCheckout = currentBreakdown.querySelector('#checkout');
    var freshCheckout = freshBreakdown.querySelector('#checkout');
    if (currentCheckout && freshCheckout) currentCheckout.className = freshCheckout.className;
  }

  function syncServerRenderedMoney(cart){
    return fetch(cartUrl('cart') + '?_bgc_fullcart_sync=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function(response){
      if (!response.ok) throw new Error('Cart HTML sync failed');
      return response.text();
    }).then(function(html){
      var freshDoc = new DOMParser().parseFromString(html, 'text/html');

      if (cart && cart.item_count === 0) {
        var currentMain = document.querySelector('.main_content_area');
        var freshMain = freshDoc.querySelector('.main_content_area');
        if (currentMain && freshMain) currentMain.innerHTML = freshMain.innerHTML;
        return;
      }

      var currentCards = cards();
      var freshCards = Array.prototype.slice.call(freshDoc.querySelectorAll('.cart_items .cart-item'));
      for (var i = 0; i < currentCards.length; i++) {
        var key = currentCards[i].getAttribute('data-bgc-key') || '';
        var freshCard = findFreshCard(freshCards, key, i);
        if (!freshCard) continue;
        syncNode(currentCards[i], freshCard, '.bgc-item-unit-price');
        syncNode(currentCards[i], freshCard, '.bgc-line-total');
        syncDiscountRows(currentCards[i], freshCard);
      }
      syncBreakdown(document, freshDoc);
    }).catch(function(){
      /* Keep the stable in-place cart if the cosmetic money sync cannot complete. */
    });
  }

  function dispatchCartUpdated(cart){
    internalCartEvent = true;
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    } catch (_e) {}
    internalCartEvent = false;
  }

  function payloadForCard(card, quantity){
    var key = lineKey(card);
    var index = rowIndex(card);
    var payload = { quantity: quantity };
    if (key) payload.id = key;
    else payload.line = index + 1;
    return payload;
  }

  function mutateQuantity(card, nextQuantity){
    if (!card || busy) return;
    var input = card.querySelector('input.quantity');
    var oldQuantity = input ? parseInt(input.value, 10) : 1;
    if (!isFinite(oldQuantity) || oldQuantity < 1) oldQuantity = 1;
    if (nextQuantity < 0) nextQuantity = 0;

    var payload = payloadForCard(card, nextQuantity);
    setBusy(card, true, nextQuantity === 0 ? 'Removing…' : 'Updating quantity…');
    if (input && nextQuantity > 0) input.value = nextQuantity;

    postChange(payload).then(function(cart){
      if (nextQuantity === 0 && card.parentNode) card.parentNode.removeChild(card);
      applyCartState(cart);
      return syncServerRenderedMoney(cart).then(function(){
        dispatchCartUpdated(cart);
        setBusy(null, false, '');
      });
    }).catch(function(){
      if (input) input.value = oldQuantity;
      setBusy(card, false, 'Could not update. Please try again.');
    });
  }

  function mutateSellingPlan(card, sellingPlan){
    if (!card || busy) return;
    var input = card.querySelector('input.quantity');
    var quantity = input ? parseInt(input.value, 10) : 1;
    if (!isFinite(quantity) || quantity < 1) quantity = 1;

    var payload = payloadForCard(card, quantity);
    payload.selling_plan = sellingPlan || null;
    setBusy(card, true, 'Updating purchase option…');

    postChange(payload).then(function(cart){
      applyCartState(cart);
      return syncServerRenderedMoney(cart).then(function(){
        dispatchCartUpdated(cart);
        setBusy(null, false, '');
      });
    }).catch(function(){
      if (cartState) applyCartState(cartState);
      setBusy(card, false, 'Could not update. Please try again.');
    });
  }

  function clickHandler(event){
    if (!isPhone()) return;

    var qtyControl = event.target && event.target.closest ? event.target.closest('.bgc-fullcart-qty-btn') : null;
    var removeControl = event.target && event.target.closest ? event.target.closest('.bgc-phone-remove') : null;
    var purchaseButton = event.target && event.target.closest ? event.target.closest('[data-bgc-fullcart-action]') : null;
    var control = qtyControl || removeControl || purchaseButton;
    if (!control) return;

    var card = control.closest('.cart-item');
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    if (busy) return;

    if (qtyControl) {
      var input = card.querySelector('input.quantity');
      var quantity = input ? parseInt(input.value, 10) : 1;
      if (!isFinite(quantity) || quantity < 1) quantity = 1;
      mutateQuantity(card, qtyControl.classList.contains('bgc-fullcart-minus') ? quantity - 1 : quantity + 1);
      return;
    }

    if (removeControl) {
      mutateQuantity(card, 0);
      return;
    }

    if (purchaseButton) {
      var panel = card.querySelector('.bgc-mobile-fullcart-purchase');
      if (!panel) return;
      var activePlan = panel.getAttribute('data-bgc-current-plan') || '';
      var action = purchaseButton.getAttribute('data-bgc-fullcart-action');
      var select = panel.querySelector('.bgc-fullcart-purchase__select');
      if (action === 'one-time') {
        if (activePlan) mutateSellingPlan(card, null);
      } else if (action === 'subscribe') {
        if (!activePlan) mutateSellingPlan(card, (select && select.value) || PLANS[0].id);
      }
    }
  }

  function changeHandler(event){
    if (!isPhone()) return;
    var select = event.target && event.target.closest ? event.target.closest('.bgc-fullcart-purchase__select') : null;
    if (!select) return;
    var card = select.closest('.cart-item');
    var panel = card && card.querySelector('.bgc-mobile-fullcart-purchase');
    if (!card || !panel || busy) return;
    var activePlan = panel.getAttribute('data-bgc-current-plan') || '';
    if (activePlan && activePlan !== select.value) mutateSellingPlan(card, select.value);
  }

  function externalCartUpdated(event){
    if (!isPhone() || internalCartEvent) return;
    var cart = event && event.detail && event.detail.cart;
    if (cart && cart.items) {
      applyCartState(cart);
      return;
    }
    fetchCart().then(applyCartState).catch(function(){});
  }

  function init(){
    if (!isPhone()) return;
    if (!document.querySelector('.cart_items')) return;
    addStyles();
    document.addEventListener('click', clickHandler, true);
    document.addEventListener('change', changeHandler, true);
    document.addEventListener('cart:updated', externalCartUpdated);
    fetchCart().then(function(cart){
      applyCartState(cart);
    }).catch(function(){
      /* Native cart remains usable; +/- links still retain their Shopify fallback URLs. */
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
